import React, { ReactElement } from 'react';
import { CUIText } from '@dotcom/crown-ui';
import { getDisplayName } from '../../../utils/address/get-display-name';
import { SelectionCardContentProps } from '../contact-types';
import styles from '../contact.module.scss';

export default function SelectionCardContent({
  contact: { first_name, last_name, display_name, address_line_1, address_line_2, city, state_code, zip, is_verified },
  topLabel,
  testId,
}: SelectionCardContentProps): ReactElement {
  const fullAddressLine = [address_line_1, address_line_2].filter(Boolean).join(', ');

  return (
    <div className={styles['contact-address-container']} data-testid={testId}>
      {topLabel && (
        <>
          <CUIText
            variant="form"
            className={styles['card-top-label-container']}
            color="textPrimary"
            data-testid="contact-top-label"
            htmlFor=""
            style={{ paddingLeft: 0 }}
          >
            {topLabel}
          </CUIText>
        </>
      )}
      <CUIText
        variant="form"
        className={styles['card-name-container']}
        htmlFor=""
        color="textPrimary"
        style={{ paddingLeft: 0 }}
      >
        {getDisplayName(first_name, last_name, display_name)}
      </CUIText>
      <CUIText
        as="div"
        className={styles['card-address-line-container']}
        data-testid="contact-address-line"
        color="textPrimary"
        title={fullAddressLine}
      >
        {address_line_1}
        {address_line_2 ? `, ${address_line_2}` : ''}
      </CUIText>
      <CUIText
        as="div"
        className={styles['card-address-city-container']}
        color="textPrimary"
        data-testid="contact-city"
      >{`${city}, ${state_code} ${zip}`}</CUIText>
    </div>
  );
}
